import React, { lazy, Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {
  getProfileAction,
  set_expiration_data_Action,
} from "../redux/actions/userProfileActions";

// import { useLoginContext } from "../contexts/authentication/authenticationProvider";
import PreLoader from "../../UI/components/preloader/preloader";

import Layout from "../../UI/layouts/layout1/layout";
import Layout2 from "../../UI/layouts/layout2/layout2";
import { apiCaller } from "../custom-hooks/useApi";
import { profile_apiCalls } from "../services/agent";

////////
const LandingPage = lazy(() => import("../../UI/pages/landing/landing.page"));
const HomePage = lazy(() => import("../../UI/pages/home/home.page"));
const PalletPage = lazy(() => import("../../UI/pages/pallet/pallet.page"));
const OrdersPage = lazy(() =>
  import("../../UI/pages/order--pages/orders/orders.page")
);
const OrdersDetailsPage = lazy(() =>
  import("../../UI/pages/order--pages/order-details/orderDetails.page")
);
const Products = lazy(() =>
  import("../../UI/pages/product--pages/products/products.page")
);
const ProductDetails = lazy(() =>
  import("../../UI/pages/product--pages/product-details/productDetails.page")
);
const EditProduct = lazy(() =>
  import("../../UI/pages/product--pages/edit-product/editProduct.page")
);
const AddProduct = lazy(() =>
  import("../../UI/pages/add-product/addProduct.page")
);
const Bargaining = lazy(() =>
  import("../../UI/pages/bargaining/bargaining.page")
);
const Profile = lazy(() => import("../../UI/pages/profile/profile.page"));
const Support = lazy(() => import("../../UI/pages/support/support.page"));
const NotFound = lazy(() => import("../../UI/pages/404/404.page"));
const AccountExpiredPage = lazy(() =>
  import("../../UI/pages/accountExpiredPage/accountExpired.page")
);

const ProducersProducts = lazy(() =>
  import(
    "../../UI/pages/store-specified-pages/producer-products/producerProducts.page"
  )
);

const ProducerProductDetails = lazy(() =>
  import(
    "../../UI/pages/store-specified-pages/producer-product-details/producerProductDetail.page"
  )
);

function RouterConfig() {
  return (
    <>
      <Suspense fallback={<PreLoader />}>
        <Routes>
          <Route path="/login" element={<LandingPage />} />
          <Route path="/" element={<PrivateOutlet />}>
            <Route path="/" element={<WithLayout1 />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/add-product" element={<AddProduct />} />
              <Route path="/products" element={<Products />} />
              <Route
                path="/productDetails/:verificationStatus/:productId"
                element={<ProductDetails />}
              />
              <Route path="/editProduct/:productId" element={<EditProduct />} />
              <Route path="/bargaining" element={<Bargaining />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route
                path="/order-details/:id"
                element={<OrdersDetailsPage />}
              />
              <Route path="/pallete" element={<PalletPage />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/support" element={<Support />} />
              <Route path="/accountexpired" element={<AccountExpiredPage />} />
              <Route
                path="/producersProducts"
                element={<ProducersProducts />}
              />
              <Route
                path="/producersProducts/:id"
                element={<ProducerProductDetails />}
              />
            </Route>
          </Route>
          <Route path="/notfound" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default RouterConfig;

function PrivateOutlet() {
  const { token } = useSelector((store) => store.userReducer);
  return token ? <Outlet /> : <Navigate to="/login" />;
}

function WithLayout1() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function WithLayout2() {
  return (
    <Layout2>
      <Outlet />
    </Layout2>
  );
}
